import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';
import * as schoolRollActions from '../school-roll/actions';
import { PARTIAL_ROLLOVER } from '../../helpers/utils';

export function* downloadTemplateForQuickUpload() {
    const response = yield call(api.downloadTemplateFile, { templateType: 'quickUpload' });
    if (response.status === 201) {
        const downloadUrl = `${response.verb.url}/${response.data}`;
        yield put(actions.downloadQuickUploadTemplateSuccess(downloadUrl, false));
    } else {
        yield put(actions.downloadQuickUploadTemplateFailure());
    }
}

export function* upload(data) {
    const response = yield call(api.verifyRollover, data.productId, data.fileContent);
    if (response.status === 200) {
        if (response.data.isSuccess) {
            const rollover = { rolloverItems: response.data.rolloverItems, rolloverType: PARTIAL_ROLLOVER };
            const uploadResponse = yield call(api.performRollover, data.productId, rollover);
            if (uploadResponse.status === 200) {
                yield put(actions.quickUploadSuccess(uploadResponse.data, true, false));
                yield put(schoolRollActions.getLicenceCapSummary(data.productId));
            } else {
                yield put(actions.quickUploadFailure(true, '', true, false));
            }
        } else {
            yield put(actions.quickUploadFailure(false, response.data.validationErrors, true, false));
        }
    } else if (response.status === 400) {
        yield put(actions.quickUploadFailure(false, response.message, true, false, true));
    } else {
        yield put(actions.quickUploadFailure(true, '', true, false));
    }
}

export function* downloadTemplateForQuickUploadSaga() {
    yield takeLatest(actions.DOWNLOAD_QUICK_UPLOAD_TEMPLATE_REQUEST, downloadTemplateForQuickUpload);
}

export function* quickUploadSaga() {
    yield takeLatest(actions.QUICK_UPLOAD_TEMPLATE_REQUEST, upload);
}



// WEBPACK FOOTER //
// ./app/containers/quick-upload/saga.js